export default __webpack_public_path__ + "static/media/card2.16b23b19.png";